const T = require('prop-types');
const { makeActionCreator } = require('../utils/redux-helpers');
const { DASHBOARD: Types } = require('../action-types');

module.exports = (context) => {

    const api = context.api.nearpeer;

    return {
        getUserStats: makeActionCreator(Types.GET_USER_STATS, {
            startDate: T.instanceOf(Date),
            endDate: T.instanceOf(Date),
            incomingClass: T.string,
            gender: T.string,
            transfer: T.string,
            roleIds: T.arrayOf(T.number),
            schoolId: T.string
        }, {
            async: api.dashboard.getUserStats
        }),
        getMessagesStats: makeActionCreator(Types.GET_MESSAGES_STATS, {
            startDate: T.instanceOf(Date),
            endDate: T.instanceOf(Date),
            schoolId: T.string
        }, {
            async: api.dashboard.getMessagesStats
        })
    };
};
